import { render, staticRenderFns } from "./volumeDynamicText.vue?vue&type=template&id=8430033a&"
import script from "./volumeDynamicText.vue?vue&type=script&lang=js&"
export * from "./volumeDynamicText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports